import request from '@/utils/request'
import MD5 from 'js-md5'

var sn = new Date().getTime();
export function http(apiCode, params) {
    
    params['requestId'] = MD5(String(sn))
    return request({
        method: 'post',
        data: params,
        headers: {
            'X-API-Code': apiCode
        }
    })
}